import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { unsubscribeMail } from "../server/api";

const STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  TIMEOUT: "timeout",
  INVALID: "invalid",
};

const SUCCESS_MESSAGE =
  "Your unsubscribe request has been processed successfully. You will no longer receive emails at this address.";
const FAILURE_MESSAGE =
  "This link may have expired, or you may not have an active subscription. Please try again later or contact us for assistance.";

const buttonStyle = {
  display: "inline-block",
  padding: "10px 22px",
  backgroundColor: "#003366",
  color: "#fff",
  textDecoration: "none",
  borderRadius: 4,
  fontWeight: 500,
};

const secondaryButtonStyle = {
  ...buttonStyle,
  backgroundColor: "#fff",
  color: "#003366",
  border: "1px solid #003366",
};

const UnsubscribeMailPage = () => {
  const [searchParams] = useSearchParams();
  const mailaddress = searchParams.get("m") || "";
  const code = searchParams.get("s") || "";

  const [status, setStatus] = useState(STATUS.LOADING);
  const [displayEmail, setDisplayEmail] = useState(mailaddress);

  useEffect(() => {
    setDisplayEmail(mailaddress);

    if (!mailaddress || !code) {
      setStatus(STATUS.INVALID);
      return;
    }

    let cancelled = false;

    unsubscribeMail({ email: mailaddress, code })
      .then((data) => {
        if (cancelled) return;
        if (data?.email) setDisplayEmail(data.email);
        if (Number(data?.msg) === 1) {
          setStatus(STATUS.SUCCESS);
          return;
        }
        setStatus(STATUS.ERROR);
      })
      .catch((error) => {
        if (cancelled) return;
        if (error.name === "TimeoutError") {
          setStatus(STATUS.TIMEOUT);
          return;
        }
        setStatus(STATUS.ERROR);
      });

    return () => {
      cancelled = true;
    };
  }, [mailaddress, code]);

  const isLoading = status === STATUS.LOADING;
  const isSuccess = status === STATUS.SUCCESS;

  return (
    <div>
      <div className="page-title">
        <h1>Unsubscribe</h1>
      </div>
      <div
        style={{
          maxWidth: "75%",
          margin: "40px auto",
          padding: "32px 24px",
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: 4,
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          position: "relative",
          minHeight: 240,
        }}
      >
        {displayEmail && (
          <div
            style={{
              position: "absolute",
              top: 24,
              left: 24,
              color: "#5d6d7e",
              fontSize: "0.95rem",
              wordBreak: "break-all",
              maxWidth: "40%",
              textAlign: "left",
            }}
          >
            {displayEmail}
          </div>
        )}

        {isLoading && (
          <div style={{ textAlign: "center", paddingTop: 48 }}>
            <Spinner animation="border" role="status" style={{ color: "#003366" }} />
            <p style={{ marginTop: 20, color: "#2c3e50" }}>
              Processing your unsubscribe request...
            </p>
          </div>
        )}

        {!isLoading && (
          <div style={{ textAlign: "center", paddingTop: 8 }}>
            <h2
              style={{
                margin: "0 0 20px",
                color: "#003366",
                fontSize: "1.6rem",
                fontWeight: 600,
              }}
            >
              {isSuccess ? "Successful" : "Unsuccessful"}
            </h2>
            <p
              style={{
                margin: "0 auto 32px",
                maxWidth: 560,
                fontSize: "1.05rem",
                color: "#2c3e50",
                lineHeight: 1.7,
              }}
            >
              {isSuccess ? SUCCESS_MESSAGE : FAILURE_MESSAGE}
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: 16, flexWrap: "wrap" }}>
              <Link to="/" style={buttonStyle}>
                Return to Homepage
              </Link>
              {!isSuccess && (
                <Link to="/about/contact_us" style={secondaryButtonStyle}>
                  Contact Administrator
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnsubscribeMailPage;
